module.exports = __webpack_public_path__ + "img/works_kiup_btm.68b42471.png";